module.exports = __webpack_public_path__ + "static/media/illustration-man-megaphone.b3284927.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/illustration-man-megaphone.svg
// module id = 1923
// module chunks = 0